import { render, staticRenderFns } from "./cropType.vue?vue&type=template&id=b54a1b58"
import script from "./cropType.vue?vue&type=script&lang=js"
export * from "./cropType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports